module.exports = __webpack_public_path__ + "img/logo.099d5423.jpg";